<template>
  <div v-if="render" class="page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="lpage-head">
      <div class="lp-main-title">{{ locationLabel }} <span>Hotels</span></div>
      <!-- <div class="lp-main-sub">Discover tours and activities that bring destinations to life</div> -->
    </div>

    <div class="att-box">
      <div class="att-side">
        <div class="filter-box">
          <div class="flt-title">Sort by</div>
          <select v-model="sort">
            <option value="lowToHigh">Price: low to high</option>
            <option value="highToLow">Price: high to low</option>
          </select>
        </div>

        <div class="filter-box">
          <div class="flt-title">Star rating</div>
          <label class="chk-field" v-for="i in 5" :key="i">
            <input type="checkbox" @click="toggleStar(i)" />
            {{ i }} star ({{ starCount[i] }})
          </label>
        </div>
      </div>

      <div class="attractions-grid">
        <hotel-card v-for="(act, i) in list" :hData="act" :key="i" v-if="(i + 1) <= showing" />
        <div class="show-more" @click="showing += 10" v-if="list.length > 10 && showing < list.length">Show more</div>
        <!-- <div class="attraction-card" v-for="act in activities" @click="view(act)">
          <div class="card-image-wrap">
            <img :src="act.HotelPicture">
            <div class="card-image-overlay"></div>
            <div class="card-cancellation" v-if="act.free_cancellation">
              <i class="fas fa-check fa-fw"></i>
              Free Cancel
            </div>
          </div>
          <div class="card-body">
            <div class="card-categories">
              <span class="cat-tag" v-for="tag in act.HotelAmenities.slice(0, 3)" :title="tag">{{ tag }}</span>
              <span class="cat-tag" v-if="act.HotelAmenities.length > 3">...</span>
            </div>
            <h3 class="card-title">{{ act.HotelName }}</h3>
            <p class="card-desc">{{ cleanTags(act.HotelAddress) }}</p>
            <div class="card-footer">
              <div class="card-price">
                <span class="currency">{{ currencySymbol[currency.code] }}</span>
                <span class="amount">{{ applyCurrency(act.Price, false) }}</span>
                <span class="per">/night</span>
              </div>
              <button class="card-btn">View Details</button>
            </div>
          </div>
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'
import hotelCard from './hotel-card'

export default {
  components: { hotelCard },
  data () {
    return {
      render: false,
      currencySymbol: currencySymbol,
      list: [],
      starCount: {
        '1': 0,
        '2': 0,
        '3': 0,
        '4': 0,
        '5': 0
      },
      showing: 10
    }
  },
  computed: {
    hotel () { return this.$store.state.hotel },
    sort: {
      get () { return this.hotel.filter.sort },
      set (x) {
        this.$store.commit('hotel/setFilterData', {sort: x})
        this.applyFilter()
      }
    },
    locationLabel () {
      if (!this.hotel.location.selected) return ''
      return this.hotel.location.selected.destinationName
    },
    activities () {
      return this.hotel.list

      // const list = this.hotel.list
      // const allowedCategories = this.hotel.filter.categories

      // let filtered = list.filter(item => {
      //   if (!item.HotelAmenities) return false
      //   const subCategories = Object.values(item.HotelAmenities)
      //   return subCategories.some(cat => allowedCategories.includes(cat))
      // })
      // return filtered
    },
    filter () { return this.hotel.filter },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    back () {
      this.$router.push('/search')
    },
    toggleCategory (x) {
      this.$store.commit('hotel/toggleFilterCategory', x)
    },
    view (x) {
      let self = this
      this.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post2(`${CONFIG.d2dAPI}/hotel/details`, {
        HotelCode: x.HotelCode,
        ResultToken: x.ResultToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!!r.Status && !r.Status) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message || 'No data available'
          })
          return
        }
        self.$store.commit('hotel/setData', {
          selected: x,
          view: r.HotelInfoResult.HotelDetails
        })
        self.$router.push('hotel/view')
      })
    },
    price (data) {
      let price = data.PublishedPrice / this.currency.list[data.CurrencyCode]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.PublishedPrice
      if (data.Currency !== 'USD' && this.currency.code !== data.CurrencyCode) {
        x = x / this.currency.list[data.CurrencyCode]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    },
    cleanTags (x) {
      let parser = new DOMParser()
      return parser.parseFromString(x, 'text/html').body.textContent.slice(0, 200)
    },
    computeStarCount () {
      let self = this
      self.starCount = {'1': 0, '2': 0, '3': 0, '4': 0, '5': 0}
      self.activities.forEach(x => {
        self.starCount[x.StarRating]++
      })
    },
    toggleStar (x) {
      this.$store.commit('hotel/toggleStar', x)
    },
    applyFilter () {
      let tmpList = JSON.parse(JSON.stringify(this.activities))

      // Star FILTER
      if (this.filter.star.length) {
        tmpList = tmpList.filter(x => this.filter.star.includes(parseInt(x.StarRating)));
      }

      // Sort FILTER
      if (this.sort === 'lowToHigh') tmpList = tmpList.sort((a, b) => a.Price.PublishedPrice - b.Price.PublishedPrice)
      else tmpList = tmpList.sort((a, b) => b.Price.PublishedPrice - a.Price.PublishedPrice)
      this.list = tmpList
    }
  },
  watch: {
    activities () {
      this.showing = 10
      this.computeStarCount()
      this.applyFilter()
    },
    'filter.star': function () {
      this.applyFilter()
    }
  },
  mounted () {
    this.render = false
    this.$store.commit('global/setAuthData', {action: ''})
    if (!this.hotel.location.selected || !Object.keys(this.hotel.location.selected).length) {
      this.back()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
    this.computeStarCount()
    this.applyFilter()
  }
}
</script>

<style lang="scss" scoped>
.page-box{
  padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;
  
  &:hover{
    color: #ff9c09;
  }
}

.lpage-head{
  margin-bottom: 24px;
}
.lp-main-title{
  font-size: 32px;
  font-weight: 700;
  color: #1a1a2e;

  span{
    color: #ECAE20;
    font-weight: 600;
  }
}
.lp-main-sub{
  font-size: 15px;
  color: #8892a0;
}

.att-box{
  display: flex;
  gap: 20px;
}
.att-side{
  width: 300px;
}

.filter-box{
  background: #fff;
  border: 2px solid #CCD0E2;
  border-radius: 4px;
  line-height: 1;
  padding: 10px;
  margin-bottom: 15px;

  .flt-title{
    display: block;
    color: #6c7c8f;
    font-size: 12px;
    margin-bottom: 4px;
  }
  select{
    padding: 0;
    width: 100%;
    border: none;
    outline: none;
    font-size: 17px;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .chk-field{
    margin: 7px 0;
    display: block;
    input{
      margin: 0 8px 0 0;
      vertical-align: -1px;
    }
  }
}

.show-more{
  margin: 0 auto;
  display: inline-block;
  padding: 10px 25px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: #999;
  letter-spacing: .6px;

  &:hover{
    color: #333;
  }
}

.attractions-grid{
  // display: grid;
  // grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}
.attraction-card{
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(236, 174, 32, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover{
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(0,0,0,0.08), 0 0 0 1px rgba(236,174,32,0.15);

    .card-image-wrap img {
      transform: scale(1.05);
    }
  }
}
.card-image-wrap {
  position: relative;
  height: 200px;
  overflow: hidden;

  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s;
  }
}
.card-image-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(26, 26, 46, 0.5) 0%, transparent 60%);
}
.card-cancellation {
  position: absolute;
  top: 14px;
  right: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(34, 197, 94, 0.9);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 20px;
}
.card-body {
  padding: 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.card-categories {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}
.cat-tag {
  font-size: 11px;
  font-weight: 600;
  color: #ECAE20;
  background: rgba(243, 191, 73, .22);
  padding: 3px 10px;
  border-radius: 20px;
  letter-spacing: .6px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 90px;
}
.card-title {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 10px;
  line-height: 1.3;
}
.card-desc {
  font-size: 13.5px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 16px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-meta {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-top: 12px;
  border-top: 1px solid #f1f3f6;
}
.card-meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #8892a0;
  font-weight: 500;

  i{
    color: #ECAE20;
  }
}
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 14px;
  border-top: 1px solid #f1f3f6;
}
.card-price {
  display: flex;
  align-items: baseline;
  gap: 4px;

  .currency {
    font-size: 13px;
    font-weight: 600;
    color: #8892a0;
  }
  .amount {
    font-size: 24px;
    font-weight: 700;
    color: #1a1a2e;
  }
  .per {
    font-size: 12px;
    color: #b0b8c4;
  }
}
.card-btn {
  padding: 10px 22px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
}

@media (max-width: 800px) {
  .attractions-grid { grid-template-columns: 1fr; }
}

@media only screen and (max-width: 641px) {
  .page-box{
    padding: 0 20px;
  }
  .bread-box{
    font-size: 14px;
    margin-bottom: 10px;
    letter-spacing: .6px;
  }
  .att-box{
    flex-direction: column;

    .att-side{
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// index.vue?7014e990